import { fetchCurrentUser } from '../../ducks/user.duck';
import { parse } from '../../util/urlHelpers';
import {
  fetchCircleAuthToken,
  fetchSpaceList,
  fetchSpecificPost,
  getCurrentUserCircleAuthParams,
  getSpaceDetails,
  getSpaceMembersList,
  requestSinglePost,
  requestSpaceDetails,
  setInitalLoadToken,
} from '../CircleCommunityPage/CircleCommunityPage.duck';

export const REQUEST_SPACE_DETAILS = 'app/DiscoverGroupPage/REQUEST_SPACE_DETAILS';
export const SUCCESS_SPACE_DETAILS = 'app/DiscoverGroupPage/SUCCESS_SPACE_DETAILS';
export const ERROR_SPACE_DETAILS = 'app/DiscoverGroupPage/ERROR_SPACE_DETAILS';

const initialState = {
  requestSpaceDetails: false,
  spaceDetailsData: null,
  errorSpaceDetails: null,
};

export default function DiscoverGroupPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case REQUEST_SPACE_DETAILS:
      return { ...state, requestSpaceDetails: true };
    case SUCCESS_SPACE_DETAILS:
      return { ...state, requestSpaceDetails: false, spaceDetailsData: payload.data };
    case ERROR_SPACE_DETAILS:
      return {
        ...state,
        requestSpaceDetails: false,
        spaceDetailsData: null,
        errorSpaceDetails: payload.error,
      };
    default:
      return state;
  }
}

// export const requestSpaceDetails = () => ({
//   type: REQUEST_SPACE_DETAILS,
// });
export const successSpaceDetails = data => ({
  type: SUCCESS_SPACE_DETAILS,
  payload: { data },
});
export const errorSpaceDetails = error => ({
  type: ERROR_SPACE_DETAILS,
  payload: { error },
});
export const loadData = (params, search, config) => async (dispatch, getState, sdk) => {
  const { page = 1 } = parse(search); // Parse the 'page' number from the search string, defaulting to 1
  const { postId, spaceId } = params; // Extract route parameters
  dispatch(requestSinglePost());
  // Fetch the current user
  return Promise.all([dispatch(fetchCurrentUser())])
    .then(async response => {
      // Get the current user's data from state
      const currentUser = getState().user.currentUser;
      const email = currentUser?.attributes?.email;

      if (email) {
        // fetch auth token on first load
        await setInitalLoadToken(getCurrentUserCircleAuthParams(currentUser));
        // // Fetch Circle auth token with pagination
        const loadPromises = [dispatch(fetchCircleAuthToken({ page: +page }))];

        // If both postId and spaceId are available, fetch post and space members
        if (postId && spaceId) {
          loadPromises.push(dispatch(fetchSpecificPost({ postId, spaceId }))); // Fetch the specific post
          loadPromises.push(dispatch(getSpaceMembersList({ space_id: spaceId }, false))); // Fetch members of the space
        }

        await Promise.all(loadPromises);
      }
      return response;
    })
    .catch(e => {
      throw e;
    });
};
